<sui-card
  class="widget-card"
  padding="flush"
  [id]="'widget-' + widget.id"
  [ngClass]="{
    preview: widgetPreview,
    fill: fill(),
    'section-break': widgetTypeId == WidgetType.WIDGET_TYPE_SECTION_BREAK,
  }"
  [frameless]="
    widgetPreview || widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
  "
  [style.--sui-card-bg]="
    widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
      ? 'transparent'
      : widgetTypeId == WidgetType.WIDGET_TYPE_SECTION_BREAK
        ? 'var(--sui-card-header-bg, var(--color-action-primary-bg))'
        : null
  "
  [selected]="objectActionService?.isObjectSelected(widget) ?? false"
  [class.widget-placeholder]="
    widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
  "
  [style.--sui-card-header-bg]="
    widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER
      ? widget.settings?.widget_header_color
      : null
  "
  [style.--sui-card-header-fg]="
    widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER ? headerTextColor : null
  "
  [class.widget-placeholder-selected]="isPlaceholderSelected"
  (click)="
    widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER
      ? selectWidgetPlaceholder()
      : null
  "
>
  <sui-card-header class="card-header widget-drag-handle">
    <div
      class="card-info"
      (click)="canEditWidget ? toggleWidgetSelect() : null"
    >
      @if (canEditWidget) {
        @if (editMode) {
          <div class="select-tool">
            <sui-checkbox
              [checked]="(isSelected$ | async) ?? false"
            ></sui-checkbox>
          </div>
        } @else {
          <div class="select-tool select-tool--spacer"></div>
        }
      } @else {
        <div class="select-tool select-tool--spacer"></div>
      }

      <sui-card-title>
        <div
          class="card-title"
          [innerHTML]="widget.title | highlight: searchString"
        ></div>
      </sui-card-title>
    </div>
    @if (editMode) {
      <sui-card-actions class="card-tools">
        @if (
          widget.widget_type_id !== WidgetType.WIDGET_TYPE_PLACEHOLDER &&
          widget.widget_type_id !== WidgetType.WIDGET_TYPE_SECTION_BREAK
        ) {
          <div class="card-tool">
            <sui-button
              size="sm"
              variant="ghost"
              [leadingIcon]="['fas', 'bars']"
              [trailingIcon]="['fas', 'caret-down']"
              [iconOnly]="true"
              ariaLabel="Widget menu"
              [expanded]="widgetMenuRef.isOpen()"
              [suiMenuTrigger]="widgetMenu"
              #widgetMenuRef="suiMenu"
            ></sui-button>
            <ng-template #widgetMenu>
              <sui-menu>
                @for (item of dropdownItems; track item) {
                  <!-- Separator -->
                  @if (item.isSeparator) {
                    <sui-menu-separator></sui-menu-separator>
                  }
                  <!-- Header -->
                  @if (item.isTitle) {
                    <sui-menu-header>
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.name }}</span>
                    </sui-menu-header>
                  }
                  <!-- Regular Item -->
                  @if (!item.isSeparator && !item.isTitle) {
                    <button sui-menu-item (click)="onItemClick(item)">
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item?.name }}</span>
                    </button>
                  }
                }
              </sui-menu>
            </ng-template>
          </div>
        }
        @if (
          widgetTypeId !== WidgetType.WIDGET_TYPE_PLACEHOLDER && canEditWidget
        ) {
          <div class="card-tool">
            <app-color-picker
              [size]="20"
              [ngModel]="widget.settings.widget_header_color"
              (ngModelChange)="updateWidgetHeaderColor($event)"
            ></app-color-picker>
          </div>
        }
        @for (tool of cardTools; track tool) {
          <div class="card-tool" (click)="tool.action()">
            <a
              suiTooltip="{{ tool.tooltip }}"
              [suiTooltipContainer]="
                widgetTypeId == WidgetType.WIDGET_TYPE_SECTION_BREAK
                  ? 'auto'
                  : null
              "
            >
              <fa-icon [icon]="tool.icon"></fa-icon>
            </a>
          </div>
        }
      </sui-card-actions>
    }
  </sui-card-header>

  @if (editMode && !widgetPreview && widget.id) {
    <div class="filter-bar">
      @if (supportsDataSources) {
        <div class="filter-items">
          @if (showDataSources$ | async) {
            @if (hasDatasources$ | async) {
              <span> {{ "widget-card.label.datasources" | translate }}: </span>
              @for (datasource of datasources$ | async; track datasource) {
                <span
                  class="datasource"
                  (click)="configureDatasourceObject(datasource)"
                  [style.backgroundColor]="
                    datasource.color ? datasource.color : null
                  "
                >
                  <fa-icon [icon]="datasource.icon"></fa-icon>
                  {{ datasource.title }}
                </span>
              }
            } @else {
              <span class="no-datasources"
                >{{ "widget-card.label.no-datasources-available" | translate }}.
                <a (click)="configureDatasource()" class="filter-tool"
                  >{{ "widget-card.label.add-datasource" | translate }}.</a
                ></span
              >
            }
          }
          @if (showFilters$ | async) {
            <sui-button
              variant="secondary"
              size="xsm"
              [leadingIcon]="['fas', 'filter']"
              [iconOnly]="true"
              [ariaLabel]="'widget-card.label.add-filter' | translate"
              [suiTooltip]="'widget-card.label.add-filter' | translate"
              (click)="configureFilters()"
            ></sui-button>
          }
          @if (showPivots$ | async) {
            <sui-button
              variant="secondary"
              size="xsm"
              [leadingIcon]="['fas', 'layer-group']"
              [iconOnly]="true"
              [ariaLabel]="'widget-card.label.add-pivot' | translate"
              [suiTooltip]="'widget-card.label.add-pivot' | translate"
              (click)="configurePivots()"
            ></sui-button>
          }
          @if (showDimensions$ | async) {
            <span class="dimensions">
              {{ "widget-card.label.dimensions" | translate }}:
            </span>
          }
          @if (
            (showFilters$ | async) && (hasFilters$ | async) && isFiltersSelected
          ) {
            @for (dimension of widget.dimensions_filter; track dimension) {
              <span class="dimension filter" (click)="editFilter(dimension)">
                <!-- funnel, not the dimension's own icon: marks the chip's
                     role (applied filter), matching the breadcrumb chips and
                     the add-filter button -->
                <fa-icon [icon]="['fas', 'filter']"></fa-icon>
                {{ dimension.title }}
                <a
                  (click)="removeFilter(dimension, $event)"
                  class="remove-filter"
                >
                  <fa-icon [icon]="['fas', 'times']"></fa-icon>
                </a>
              </span>
            }
          }
          @if (
            (showPivots$ | async) && (hasPivots$ | async) && isPivotsSelected
          ) {
            @for (dimension of widget.dimensions_pivot; track dimension) {
              <span class="dimension pivot" (click)="editFilter(dimension)">
                <!-- layer-group = pivot role, same icon as the add-pivot
                     button; keeps pivot chips distinguishable from filters -->
                <fa-icon [icon]="['fas', 'layer-group']"></fa-icon>
                {{ dimension.title }}
                <a
                  (click)="removePivot(dimension, $event)"
                  class="remove-filter"
                >
                  <fa-icon [icon]="['fas', 'times']"></fa-icon>
                </a>
              </span>
            }
          }
          @if (hasCustomPeriod && periodTimeStart && periodTimeEnd) {
            <span class="widget-period">
              <fa-icon [icon]="['fas', 'calendar']"></fa-icon>
              <span class="period-dates">
                {{ periodTimeStart * 1000 | date: "dd MMM yyyy, HH:mm" }} –
                {{ periodTimeEnd * 1000 | date: "dd MMM yyyy, HH:mm" }}
              </span>
            </span>
          }
          @if (hasOverrideOutputSettings) {
            <span
              class="widget-override-output-settings"
              [suiTooltip]="
                'widget-card.tooltip.this-widget-uses-custom-output-settings'
                  | translate
              "
            >
              <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
              {{ "widget-card.label.custom-output-settings" | translate }}
            </span>
          }
        </div>
      }
    </div>
  }

  <div
    class="widget-content"
    #widgetContent
    appInView
    (inView)="handleVisibilityChange($event)"
  >
    @if (
      isWidgetLoading &&
      widgetTypeId != WidgetType.WIDGET_TYPE_PLACEHOLDER &&
      widgetTypeId != WidgetType.WIDGET_TYPE_SECTION_BREAK &&
      showLoading
    ) {
      <app-loading></app-loading>
    }
    @if (widgetTypeId == WidgetType.WIDGET_TYPE_PLACEHOLDER) {
      <span class="plus-sign">
        <fa-icon [icon]="['fas', 'plus']"></fa-icon>
      </span>
    }

    @if (!isWidgetLoading || !showLoading) {
      @if (loadError(); as message) {
        <div class="widget-load-error">
          <sui-empty-state
            tone="danger"
            [icon]="['fas', 'circle-exclamation']"
            [title]="
              'widget-card.message.the-widget-could-not-be-loaded' | translate
            "
            [description]="message"
          >
            <sui-button
              variant="secondary"
              [leadingIcon]="['fas', 'sync']"
              (click)="reloadWidget()"
            >
              {{ "btn.retry" | translate }}
            </sui-button>
          </sui-empty-state>
        </div>
      } @else if (!hasResults() && !shouldHideMessage(widgetTypeId)) {
        <app-no-results [message]="noContentMsg"></app-no-results>
      } @else {
        @if (isHighchart && chartOptions().length > 0) {
          <highcharts-chart
            [Highcharts]="Highcharts"
            [oneToOne]="true"
            [constructorType]="chartConstructor()"
            [options]="chartOptions()[currentChartIndex()]"
            [callbackFunction]="chartCallback"
            style="width: 100%; height: 100%; display: block; min-height: 200px"
          >
          </highcharts-chart>
        }

        @if (widgetTypeId === WidgetType.WIDGET_TYPE_TABLE) {
          <div
            class="table-responsive"
            style="width: 100%; height: 100%; overflow: auto"
          >
            @if (tableData() && tableData()[0] && tableData()[0].data) {
              <table class="table table-hover" style="margin-block-end: 0px">
                @for (record of tableData()[0].data; track record) {
                  <tr>
                    <td>
                      <a>{{ record.name }}</a>
                    </td>
                    <td style="text-align: right">
                      <b>{{ record.y }}</b>
                    </td>
                  </tr>
                }
              </table>
            } @else {
              <table class="table table-hover" style="margin-block-end: 0px">
                <tr>
                  <td colspan="2">
                    {{
                      "widget-card.label.no-data-table-avaialble" | translate
                    }}
                  </td>
                </tr>
              </table>
            }
          </div>
        }
        @if (widgetTypeId === WidgetType.WIDGET_TYPE_POST_LIST) {
          <div class="card-container posts">
            @for (post of posts(); track post) {
              <app-post-card
                [post]="post"
                [user]="user"
                [feedId]="widget?.datasources[0]?.id"
                [objectTypeId]="widget?.datasources[0]?.object_type_id"
                [backgroundColor]="widget.settings?.post_background_color"
                [selectable]="false"
                [removable]="false"
                [allowRelatedPosts]="true"
                [viewConfig]="postCardViewConfig"
              ></app-post-card>
            }
          </div>
        }
      }
    }
  </div>

  @if (!isWidgetLoading && widgetItems()?.length > 1) {
    <div class="chart-tabs-holder">
      @for (item of widgetItems(); track item; let i = $index) {
        <div (click)="changeIndex(i)" class="tabs">
          <div class="tab" [class.active]="i === currentChartIndex()">
            {{ item.title }}
          </div>
        </div>
      }
    </div>
  }
</sui-card>
